import React, { useContext, useEffect } from 'react'
import './index.scss'
import Button from '@Components/Buttons/Button'
import { ICONS } from '@Const/common'
import { useNavigate } from 'react-router'
import { analyticsSendPage } from '@App/common/utils/analytics-utils'
import { StoresContext } from '@App/contexts'

const AccessDeniedScene = () => {
    const { userStore } = useContext(StoresContext)

    const navigate = useNavigate()
    const goBack = () => navigate(-1)

    useEffect(() => {
        analyticsSendPage('access_denied')
    }, [])

    return (
        <>
            <title>Access Denied</title>
            <main className="access-denied-scene">
                <div className="global-container">
                    <div className="message-block">
                        <img src={ICONS.mlc_logo} alt="logo" />
                        <h1>403</h1>
                        <h3>Sorry, you are forbidden to access this page.</h3>
                        {!userStore.userInfo.isInternal && (
                            <Button mainColor type="primary" onClick={goBack}>
                                Go Back
                            </Button>
                        )}
                    </div>
                </div>
            </main>
        </>
    )
}

export default AccessDeniedScene
